import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-error-bib-dialog',
  templateUrl: './error-bib-dialog.component.html',
  styleUrls: ['./error-bib-dialog.component.scss'],
})
export class ErrorBibDialog {
  reply1: any = 'yes';
  reply2: any = 'no';

  constructor(
    public dialogRef: MatDialogRef<ErrorBibDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  download() {
    this.dialogRef.close('yes');
  }
}
